<template>
    <footer class="footer">
        <div class="container">
            <div class="row justify-content-between align-items-center">
                <!-- Logo and Description -->
                <div class="col-lg-4 col-12 text-center mb-4 mb-lg-0" 
                     :class="this.$i18n.locale === 'ar' ? 'text-lg-end' : 'text-lg-start'">
                    <img src="@/assets/images/logo.png" alt="Logo" class="footer-logo">
                    <p class="footer-text">
                        {{$t('footer.title')}}
                    </p>
                    <div class="social-icons">
                        <a href="#"><img src="@/assets/images/social/youtube.png" alt="YouTube"></a>
                        <a href="#"><img src="@/assets/images/social/instagram.png" alt="Instagram"></a>
                        <a href="#"><img src="@/assets/images/social/x.png" alt="X"></a>
                    </div>
                </div>

                <!-- Links and Contact -->
                <div class="col-lg-8 col-12">
                    <div class="row">
                        <!-- Important Links -->
                        <div class="col-lg-4 col-12 mb-4 mb-lg-0 text-center"
                             :class="this.$i18n.locale === 'ar' ? 'text-lg-end' : 'text-lg-start'">
                            <h5 class="footer-title">{{ $t('footer.important_links') }}</h5>
                            <ul class="footer-links">
                                <li><a href="#">{{ $t('footer.about_us') }}</a></li>
                                <li><a href="#">{{ $t('footer.our_services') }} </a></li>
                                <li><a href="#"> {{ $t('footer.quran_programs') }}</a></li>
                                <li><a href="#"> {{ $t('footer.electronic_reading') }}</a></li>
                            </ul>
                        </div>

                        <!-- Contact -->
                        <div class="col-lg-4 col-12 mb-4 mb-lg-0 text-center"
                             :class="this.$i18n.locale === 'ar' ? 'text-lg-end' : 'text-lg-start'">
                            <h5 class="footer-title"> {{ $t('footer.contact_us') }}</h5>
                            <ul class="footer-links">
                                <li><img src="@/assets/images/social/location.png" alt="Location"> {{ $t('footer.address') }}</li>
                                <li><img src="@/assets/images/social/phone.png" alt="Phone"> +966 53 190 3600</li>
                                <li><img src="@/assets/images/social/message.png" alt="Email"> info@forqan.com</li>
                            </ul>
                        </div>

                        <!-- Privacy -->
                        <div class="col-lg-4 col-12 text-center"
                             :class="this.$i18n.locale === 'ar' ? 'text-lg-end' : 'text-lg-start'">
                            <h5 class="footer-title">{{$t('footer.privacy')}}</h5>
                            <ul class="footer-links">
                                <li><a href="#"> {{ $t('footer.privacy_policy') }}</a></li>
                                <li><a href="#">{{ $t('footer.terms') }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Copyright -->
            <div class="footer-bottom">
                <p>{{$t('footer.copyrights') + ' © ' + new Date().getFullYear()}}</p>
            </div>
        </div>
    </footer>
</template>

<style scoped>
.footer {
    background-color: #FAF7EF;
    padding: 40px 0;
}

.footer-logo {
    width: 102px;
    height: 159px;
    object-fit: cover;
    margin-bottom: 15px;
}

.footer-text {
    font-size: 18px;
    font-weight: 400;
    color: #393735;
}

.footer-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
}

.footer-links {
    list-style: none;
    padding: 0;
}

.footer-links li {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.footer-links a {
    text-decoration: none;
    color: #393735;
    transition: 0.3s;
    font-size: 18px;
    font-weight: 400;
}

.footer-links a:hover {
    color: #c19b77;
}

.social-icons {
    margin-top: 15px;
}

.social-icons a {
    margin: 0 5px;
}

.social-icons img {
    width: 32px;
    height: auto;
    object-fit: contain;
}

.footer-bottom {
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #ddd;
    margin-top: 20px;
    font-size: 18px;
    font-weight: 400;
    color: #393735;
}

/* Responsive adjustments */
@media (max-width: 767.98px) {
    .footer-links {
        text-align: center;
    }

    .footer-links li {
        justify-content: center;
    }

    .footer-title {
        text-align: center;
    }
}
</style>